// Utility functions for consistent state name formatting across components

export const stateNameToMapFormat = (stateName: string): string => {
  if (!stateName) return '';
  return stateName.toLowerCase().replace(/\s+/g, '_');
};
